import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './styles.css';
import { useDatesModalAutoOpen } from './utils/useDatesModalAutoOpen';
import { Filters } from '../../../../packages/Filters';
import { checkIsHotelsSearch } from '../../../../packages/JsonQuery/utils/checkIsHotelsSearch';
import { Desktop, NotDesktop } from '../../../../packages/Responsive';
import { RedesignedFiltersPanelContainer } from '../../../FiltersMobile/containers';
import { SidebarContainer } from '../../../ListingDesktop/containers/SidebarContainer';
import { ListingModalContainer } from '../../../ListingMobile/containers/ListingModal';
import { Map } from '../../../Map/containers/Map';
import { EListingModalMode, EOffersFetchingMode, toggleModal } from '../../actions/listingModal';
import { loadListingOffers } from '../../actions/listingOffers';
import { PageLayout } from '../../components/PageLayout';
import { useFiltersUxfbPoll } from '../../hooks/useUxFbPoll';
import { selectResultsJsonQuery } from '../../selectors/results';
import { IListingOffersState } from '../../types/listingOffers';
import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { FiltersContainer } from '../FiltersContainer';
import { SaveSearchButtonContainer } from '../FiltersContainer/SaveSearchButton';
import { NavigationContainer } from '../Navigation';
import { Notifications } from '../Notifications';
import { SaveSearchModalContainer } from '../SaveSearchModalContainer';

export function PageContainer() {
  const dispatch = useDispatch<TThunkDispatch>();
  const jsonQuery = useSelector(selectResultsJsonQuery);
  const listingOffersState = useSelector<IApplicationState, IListingOffersState>(state => state.listingOffers);
  const isHotelsSearch = checkIsHotelsSearch(jsonQuery);
  const showSaveSearchButton = !isHotelsSearch;

  useDatesModalAutoOpen();
  useFiltersUxfbPoll();

  React.useEffect(() => {
    dispatch(
      toggleModal({ open: true, mode: EListingModalMode.HALF_SCREEN, offersFetchingMode: EOffersFetchingMode.ALL }),
    );

    if (!listingOffersState.offers?.length) {
      dispatch(loadListingOffers({ offersFetchingMode: EOffersFetchingMode.ALL }));
    }
  }, []);

  return (
    <>
      <PageLayout
        map={<Map />}
        navigation={
          <FiltersContainer>
            <NotDesktop>
              <RedesignedFiltersPanelContainer />
            </NotDesktop>
            <Desktop>
              <Filters savedSearch={showSaveSearchButton && <SaveSearchButtonContainer />} />
              <NavigationContainer />
            </Desktop>
          </FiltersContainer>
        }
        sidebar={
          <>
            <NotDesktop>
              <FiltersContainer>
                <ListingModalContainer />
              </FiltersContainer>
            </NotDesktop>
            <Desktop>
              <FiltersContainer>
                <SidebarContainer />
              </FiltersContainer>
            </Desktop>
          </>
        }
      />
      <SaveSearchModalContainer />
      <Notifications />
    </>
  );
}
